import { Box, CircularProgress } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';

import { useHeader } from '@app/components/common/navigation/hooks/header-service';
import { useAlert, useEntityState } from '@app/hooks';
import { api } from '@app/api';
import { User } from '@app/api/models/user';

import { UserForm } from './form';
import { mapInstance } from './utils/mapInstance';
import { UserFormInstance } from './types';
import Error404 from '../../pages/errors/404';
import { useAvailableUsers } from './hooks/useAvailableUsers';

const UserEdit = () => {
  useHeader('Изменить пользователя', []);
  const params = useParams<{ id: string }>();

  const { state } = useLocation<{ user?: User }>();

  const history = useHistory();
  const { success, error } = useAlert();
  const [_, setIsFetching] = useState<boolean>(false);
  const [instance, onChange, setInstance] =
    useEntityState<UserFormInstance>(undefined);

  const { availableUsers, loadingUsers } = useAvailableUsers();

  useEffect(() => {
    if (loadingUsers) {
      return;
    }
    setInstance({
      user_id: state.user.id.toString(),
      ...state?.user,
    });

    if (instance?.leader?.id) {
      onChange('boss')(availableUsers.find(({ id }) => (id as string).includes(instance.leader.id.toString())));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id, state, loadingUsers, availableUsers]);

  const onFormSubmit = async (instance: Partial<UserFormInstance>) => {
    setIsFetching(true);
    try {
      const response = await api.users.modify(mapInstance(instance));
      if (response.data.code === 200) {
        setIsFetching(false);
        success('Пользователь изменен');
        history.goBack();
      } else {
        setIsFetching(false);
        error(response.data.message);
      }
    } catch (e) {
      console.log(e);

      setIsFetching(false);
      error(e.message);
    }
  };

  const onFormCancel = () => {
    history.goBack();
  };

  if (!state?.user) {
    return <Error404 />;
  }

  return (<>
      {!instance ? (
        <Box
          width="100%"
          height="300px"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress size={24} />
        </Box>
      ) : (
        <UserForm
          action='edit'
          availableUsers={availableUsers}
          loadingUsers={loadingUsers}
          instance={instance}
          onSubmit={onFormSubmit}
          onCancel={onFormCancel}
          onChange={onChange}
        />)
      }
    </>
  );
};

export default UserEdit;
